module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic01.0968331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic01.png
// module id = 501
// module chunks = 1